// Frontend input validation utilities
export function validateEventTitle(title) {
  if (!title || typeof title !== 'string') {
    return { isValid: false, error: 'Title is required' };
  }
  
  const trimmed = title.trim();
  if (trimmed.length === 0) {
    return { isValid: false, error: 'Title cannot be empty' };
  }
  
  if (trimmed.length > 200) {
    return { isValid: false, error: 'Title must be less than 200 characters' };
  }
  
  // Check for potentially dangerous content
  if (/<script|javascript:|on\w+=/i.test(trimmed)) {
    return { isValid: false, error: 'Title contains invalid content' };
  }
  
  return { isValid: true, value: trimmed };
}

export function validateEventDescription(description) {
  if (!description) {
    return { isValid: true, value: '' };
  }
  
  if (typeof description !== 'string') {
    return { isValid: false, error: 'Description must be text' };
  }
  
  const trimmed = description.trim();
  if (trimmed.length > 1000) {
    return { isValid: false, error: 'Description must be less than 1000 characters' };
  }
  
  // Check for potentially dangerous content
  if (/<script|javascript:|on\w+=/i.test(trimmed)) {
    return { isValid: false, error: 'Description contains invalid content' };
  }
  
  return { isValid: true, value: trimmed };
}

export function validateEventLocation(location) {
  if (!location) {
    return { isValid: true, value: '' };
  }
  
  if (typeof location !== 'string') {
    return { isValid: false, error: 'Location must be text' };
  }
  
  const trimmed = location.trim();
  if (trimmed.length > 200) {
    return { isValid: false, error: 'Location must be less than 200 characters' };
  }
  
  // Check for potentially dangerous content
  if (/<script|javascript:|on\w+=/i.test(trimmed)) {
    return { isValid: false, error: 'Location contains invalid content' };
  }
  
  return { isValid: true, value: trimmed };
}

export function validateUsername(username) {
  if (!username || typeof username !== 'string') {
    return { isValid: false, error: 'Username is required' };
  }
  
  const trimmed = username.trim();
  if (trimmed.length < 3 || trimmed.length > 50) {
    return { isValid: false, error: 'Username must be 3-50 characters' };
  }
  
  if (!/^[a-zA-Z0-9_]+$/.test(trimmed)) {
    return { isValid: false, error: 'Username can only contain letters, numbers, and underscores' };
  }
  
  return { isValid: true, value: trimmed };
}

export function validateEmail(email) {
  if (!email || typeof email !== 'string') {
    return { isValid: false, error: 'Email is required' };
  }
  
  const trimmed = email.trim().toLowerCase();
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
  if (!emailRegex.test(trimmed)) {
    return { isValid: false, error: 'Please enter a valid email address' };
  }
  
  if (trimmed.length > 100) {
    return { isValid: false, error: 'Email must be less than 100 characters' };
  }
  
  return { isValid: true, value: trimmed };
}

export function validateTruckName(truckName) {
  if (!truckName) {
    return { isValid: true, value: '' };
  }
  
  if (typeof truckName !== 'string') {
    return { isValid: false, error: 'Truck name must be text' };
  }
  
  const trimmed = truckName.trim();
  if (trimmed.length > 100) {
    return { isValid: false, error: 'Truck name must be less than 100 characters' };
  }
  
  // Check for potentially dangerous content
  if (/<script|javascript:|on\w+=/i.test(trimmed)) {
    return { isValid: false, error: 'Truck name contains invalid content' };
  }
  
  return { isValid: true, value: trimmed };
}

export function validateDescription(description) {
  if (!description) {
    return { isValid: true, value: '' };
  }
  
  if (typeof description !== 'string') {
    return { isValid: false, error: 'Description must be text' };
  }
  
  const trimmed = description.trim();
  if (trimmed.length > 500) {
    return { isValid: false, error: 'Description must be less than 500 characters' };
  }
  
  // Check for potentially dangerous content
  if (/<script|javascript:|on\w+=/i.test(trimmed)) {
    return { isValid: false, error: 'Description contains invalid content' };
  }
  
  return { isValid: true, value: trimmed };
}

export function validateInstagramHandle(instagram) {
  if (!instagram || typeof instagram !== 'string') {
    return { isValid: false, error: 'Instagram handle is required' };
  }
  
  const trimmed = instagram.replace(/^@/, '').trim();
  
  if (trimmed.length === 0) {
    return { isValid: false, error: 'Instagram handle cannot be empty' };
  }
  
  if (trimmed.length > 30) {
    return { isValid: false, error: 'Instagram handle must be less than 30 characters' };
  }
  
  if (!/^[a-zA-Z0-9._]+$/.test(trimmed)) {
    return { isValid: false, error: 'Instagram handle can only contain letters, numbers, dots, and underscores' };
  }
  
  return { isValid: true, value: trimmed };
}

export function validatePassword(password) {
  if (!password || typeof password !== 'string') {
    return { isValid: false, error: 'Password is required' };
  }
  
  if (password.length < 6) {
    return { isValid: false, error: 'Password must be at least 6 characters' };
  }
  
  if (password.length > 128) {
    return { isValid: false, error: 'Password must be less than 128 characters' };
  }
  
  return { isValid: true, value: password };
}

export function validateCoordinates(lat, lng) {
  const latitude = parseFloat(lat);
  const longitude = parseFloat(lng);
  
  if (isNaN(latitude) || isNaN(longitude)) {
    return { isValid: false, error: 'Invalid coordinates' };
  }
  
  if (latitude < -90 || latitude > 90) {
    return { isValid: false, error: 'Latitude must be between -90 and 90' };
  }
  
  if (longitude < -180 || longitude > 180) {
    return { isValid: false, error: 'Longitude must be between -180 and 180' };
  }
  
  return { isValid: true, latitude, longitude };
}